import React from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'styles/css/quill.snow.css';
import "regenerator-runtime/runtime.js";
import ImageResize from 'quill-image-resize-module';

Quill.register('modules/imageResize', ImageResize);

const YOUTUBE_ICON = 
  '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" \
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" width="18px" height="18px"> \
<path style="fill:#D8362A;" d="M506.703,145.655c0,0-5.297-37.959-20.303-54.731c-19.421-22.069-41.49-22.069-51.2-22.952 \
	C363.697,62.676,256,61.793,256,61.793l0,0c0,0-107.697,0.883-179.2,6.179c-9.71,0.883-31.779,1.766-51.2,22.952 \
	C9.71,107.697,5.297,145.655,5.297,145.655S0,190.676,0,235.697v41.49c0,45.021,5.297,89.159,5.297,89.159 \
	s5.297,37.959,20.303,54.731c19.421,22.069,45.021,21.186,56.497,23.835C122.703,449.324,256,450.207,256,450.207 \
	s107.697,0,179.2-6.179c9.71-0.883,31.779-1.766,51.2-22.952c15.007-16.772,20.303-54.731,20.303-54.731S512,321.324,512,277.186 \
	v-41.49C512,190.676,506.703,145.655,506.703,145.655"/> \
<polygon style="fill:#FFFFFF;" points="194.207,166.841 194.207,358.4 361.931,264.828 "/> \
</svg>'

const formats = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent',
  'link', 'image', 'video',
  'background', 'align', 'color', 'width'
]

let icons = Quill.import('ui/icons');
icons['ytube'] = YOUTUBE_ICON;

let Inline = Quill.import('blots/inline');
class LinkBlot extends Inline {
  static create(value) {
    let node = super.create();
    let valueStripped = value.replace(/\w{4,5}\:\/\//i,'');
    node.setAttribute('href', 'http://' + valueStripped);
    node.setAttribute('target', '_blank');
    return node;
  }

  static formats(node) {
    return node.getAttribute('href');
  }
}
LinkBlot.blotName = 'link';
LinkBlot.tagName = 'a';

Quill.register(LinkBlot);

export default class QuillEditor extends React.Component {
  constructor(props) {
      super(props)
      this.modules = {
        toolbar: {
          container: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }, { 'font': [] }],
            [{size: []},{ 'color': [] },{'background': []}],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'align': [] }],
            [{'list': 'ordered'}, {'list': 'bullet'},
            {'indent': '-1'}, {'indent': '+1'}],
            ['link', 'image', 'video', 'ytube'],
            ['clean']
          ],
          handlers:{
            ytube: () => this.toggleYtube()
          }
        },
         clipboard: {
          matchVisual: true
        },
        imageResize: {
          // modules: [ 'Resize', 'DisplaySize', 'Toolbar' ],
          modules: [ 'Resize', 'DisplaySize' ],
          parchment: Quill.import('parchment')
        }
      }
      this.state = {
        showYoutubeInput: false,
        youtubeLink: '',
        editorIndex: null,
        tooltipTopPosition: null
      }
      this.reactQuillRef=null;
  }

  componentWillMount() {
    ReactQuill.Quill.register('modules/imageResize', ImageResize);
    document.addEventListener("mousedown", this.checkRteTooltip, false);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.checkRteTooltip, false);
  }

  toggleYtube = () => {
      const editor = this.reactQuillRef.getEditor();
      const index = editor.getSelection().index || 0;
      const bounds = editor.getBounds(index);
      // console.log('bounds = ', bounds);
    this.setState({
      showYoutubeInput: true,
      editorIndex: index,
      tooltipTopPosition: bounds.top + 50,
    })
  }

  insertYtube = () => {
    let embedYT = this.state.youtubeLink;
    this.setState({
      showYoutubeInput: false,
      youtubeLink: ''
    })
    if (embedYT) {
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
      var match = embedYT.match(regExp);
      if (match && match[2].length == 11) {
        if (embedYT.match('https://youtu.be/')) {
          embedYT = embedYT.replace("https://youtu.be/", "https://www.youtube.com/embed/");
        }
        else {
          embedYT = embedYT.replace("https://www.youtube.com/watch?v=", "https://www.youtube.com/embed/");
        }
        if (embedYT.match(/\?t=\d+/)) {
          embedYT = embedYT.replace(/\?t=/, "?start=")
        }
        this.reactQuillRef.getEditor().insertEmbed(this.state.editorIndex, 'video', embedYT);
      }

      // code to insert any HTML tag into editor;
      //
      // var tube = `<iframe frameborder="0" allowfullscreen="true" src=${embedHtml} width="560"></iframe>`;
      // editor.clipboard.dangerouslyPasteHTML(index,tube);
    }
  }

  checkRteTooltip = (e) => {
    if (this.tooltipRef && !this.tooltipRef.contains(e.target)) {
      this.setState({
        showYoutubeInput: false,
        youtubeLink: ''
      })
    }
  }

  render() {
    return (
      <div>
        <ReactQuill
          ref = { (el) => { this.reactQuillRef = el; } }
          theme={this.props.theme === null ? null : 'snow'}
          onChange={this.props.onChange || null}
          value={this.props.value}
          {...this.props.showToolbar ? ({ modules: this.modules, formats: formats} ) : {} }
          placeholder={this.props.placeholder || ''}
          className={this.props.className || 'quill-rte'}
          readOnly={this.props.readOnly === true ? true : false}
        />
        {this.state.showYoutubeInput && 
          <div className='custom-rte-tooltip' style={{top: `${this.state.tooltipTopPosition}px`}} ref = { (el) => { this.tooltipRef = el; } }>
            <span>Enter YouTube video:</span>
            <input type="text" onChange={(e) => [e.preventDefault(), this.setState({youtubeLink: e.target.value})]} placeholder='YouTube video share link' autoFocus/>
            <span onClick={() => this.insertYtube()}>Save</span>
          </div>
        }
      </div>

    )
  }
}




// WEBPACK FOOTER //
// ./src/components/create_workshop/QuillEditor.jsx